import { Amount } from "../amount"
import { summon, AType } from "@silversea-ssc/functional-support"
import { PaxPrice } from "./pax-price"
import { Inclusion } from "./inclusion"

export const SuitePrice = summon((F) =>
    F.interface(
        {
            total: Amount(F),
            originalTotal: F.nullable(Amount(F)),
            paxPrices: F.array(PaxPrice(F)),
            inclusions: F.array(Inclusion(F)),
        },
        "SuitePrice",
    ),
)
export type SuitePrice = AType<typeof SuitePrice>
